// Copie presse-papiers — source unique.
//
// `navigator.clipboard` n'existe **pas en contexte non sécurisé** : le CRM est
// servi en HTTP en local (http://62.210.94.68:3097) et l'API y est absente.
// Le repli `execCommand('copy')` sur un textarea hors écran, déjà employé dans
// JDMAAnalyseIA et ProspectionContactsCell, reste donc nécessaire — ce module
// factorise ce duo pour éviter de le réécrire à chaque usage.
//
// Renvoie `true` si la copie a abouti, `false` sinon : l'appelant décide quoi
// afficher, la fonction ne lève jamais.
export async function copierTexte(texte) {
  const valeur = String(texte ?? '');
  if (!valeur) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(valeur);
      return true;
    }
  } catch { /* contexte non sécurisé ou permission refusée : on tente le repli */ }

  const ta = document.createElement('textarea');
  ta.value = valeur;
  // Hors écran mais focalisable : `display:none` empêcherait la sélection.
  ta.style.position = 'fixed';
  ta.style.top = '-9999px';
  ta.style.opacity = '0';
  ta.setAttribute('readonly', '');
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { /* repli indisponible */ }
  document.body.removeChild(ta);
  return ok;
}
